import { isMac } from "./keys";

/** A shortcut's modifier for on-screen hints: ⌘ drawn as an icon on a Mac (the text glyph renders thin and fuzzy in
 *  small UI type), "Ctrl+" elsewhere. Screen readers hear "Command". */
export function ModKey({ k }: { k: string }) {
  if (!isMac()) return <>Ctrl+{k}</>;
  return (
    <span className="mod-k">
      <svg
        className="mod-ic"
        width="10"
        height="10"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3" />
      </svg>
      <span className="sr-only">Command </span>
      {k}
    </span>
  );
}
